import './HomeSection.css'

function HomeSection() {
 return (
    <div id={"home-section"} className='scrollable-section'>
        <div className='home-text-container'>
            <h1>Calm Your Mind. Clear the Noise. See Your Next Step.</h1>
            <h2>Helping people release what’s heavy and move forward with clarity.</h2>
        </div>
    </div>
 )
}

export default HomeSection